export enum WhoPrepType {
  SELLER = 'SELLER',
  AMAZON = 'AMAZON',
  NONE = 'NONE'
}
